<template>
  <ul class="badge-section" aria-label="Compliance and Regulatory Badges">
    <li v-for="badge in badges" :key="badge.text" class="badge">
      <img :src="badge.icon" class="icon-svg" alt="" aria-hidden="true" />
      <p>{{ badge.text }}</p>
    </li>
  </ul>
</template>

<script setup>
const badges = [
  {
    icon: "/icons/compliance-sebi.svg",
    label: "SEBI Registered Agent",
    text: "SEBI Registered",
  },
  {
    icon: "/icons/compliance-rbi.svg",
    label: "RBI Regulated Fixed Deposits",
    text: "RBI Regulated FDs",
  },
  {
    icon: "/icons/compliance-member.svg",
    label: "Member with BSE and NSE",
    text: "Member with BSE & NSE",
  },
];
</script>

<style scoped>
.badge-section {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.badge {
  display: flex;
  gap: 4px;
  align-items: center;
}

p {
  font-size: 12px;
}

.icon-svg {
  width: 18px;
  height: 18px;
}

@media (min-width: 1024px) {
  p {
    font-size: 15px;
  }

  .icon-svg {
    width: 21px;
    height: 21px;
  }
}
</style>
